import React, { CSSProperties, useState, useEffect } from 'react';
import styled from 'styled-components';
import {CONSTS} from './_constants';
import { Pagination } from '.';
import { ITEMS_PER_PAGE } from '../../inc/constants';

type colTyped = {
    title: string
    dataIndex: string
    style?: CSSProperties
    render?: Function
}
type tableOptionsTyped = {
    rowStyle?: CSSProperties | Function
}
type tablePropsType = {
    columns?: colTyped[],
    dataSource?:any[],
    className?: string,
    pagination?:true,
    options?: tableOptionsTyped
}

const Table = (props:  tablePropsType) => {
    const {columns, className, options} = props;
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [sortKey, setSortKey] = useState(null);
    const [sortAsc, setSortAsc] = useState(1);
    const [currPage, setCurrPage] = useState(1);

    const pages = dataSource ? Math.ceil(dataSource.length / ITEMS_PER_PAGE) : 0;

    useEffect(() => {
        if(props.dataSource)
            setDataSource(props.dataSource);
    }, [props])

    const sort = (indx:any) => {
        const compare = (a:any, b:any) => {
            if(a[indx] < b[indx])
                return -1 * sortAsc;
            else if(a[indx] > b[indx])
                return sortAsc;
            return 0;
        }
        if(dataSource){
            if(indx == sortKey) setSortAsc(sortAsc * -1);
            else setSortAsc(1);
            setSortKey(indx);
            var tmp = [...dataSource];
            tmp.sort(compare);
            setDataSource(tmp);
        }
    }

    return(
        <>
            <table className={className}>
                <thead>
                    <tr>
                        {columns && columns.map((col, key) => 
                        <td
                         className={(sortKey==col.dataIndex && sortAsc==1) ? "sorted" : ""}
                         onClick={() => sort(col.dataIndex)} 
                         key={key}
                         style={col.style}
                         >
                            {col.title}
                        </td>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {dataSource && dataSource.slice((currPage-1)*ITEMS_PER_PAGE, currPage*ITEMS_PER_PAGE).map((record, i) => {
                        let rowStyle;
                        if(options && options.rowStyle){
                            if(typeof(options.rowStyle) === "function")
                                rowStyle = options.rowStyle(record);
                            else
                                rowStyle = options.rowStyle;
                        }
                        return (
                            <tr key={i} style={rowStyle}>
                                {columns && 
                                    columns.map((col, key) => {
                                        return (
                                            <td key={key}>{col.render ? col.render(record[col.dataIndex]) : record[col.dataIndex]}</td>
                                        )
                                    })
                                }
                                
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <Pagination pages={pages} current={currPage} onChange={setCurrPage} />
        </>
    )
}

const StyledTable = styled(Table)`
    width: 100%;
    
    border-collapse: separate;
    border-spacing: 0 10px;
    > thead{
        font-size: 14px;
        /* color: rgba(211, 212, 218, 1); */
        > tr{
            > td{
                color: ${CONSTS.colors.greyDark};
                font-weight: 500;
                padding: 5px 10px;
                position: relative;
                cursor: pointer;
                &::before{
                    position: absolute;
                    opacity: 0;
                    transition: opacity .25s;
                    content: '';
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 0;
                    height: 0;
                    border-top: 5px solid #eee;
                    border-bottom: 5px solid transparent;
                    border-right: 5px solid transparent;
                    border-left: 5px solid transparent;
                }
                &.sorted{
                    &::before{
                        border-top: 5px solid transparent;
                        border-bottom: 5px solid #eee;
                    }
                }
                &:hover{
                    &::before{
                        opacity: 1;
                    }
                }
            }
        }
    }
    > tbody{
        color: rgba(77, 76, 101, 1);
        font-size: 12px;
        > tr{
            > td{
                padding: 10px;
                line-height: 20px;
                border-top: 1px solid ${CONSTS.colors.grey};
                border-bottom: 1px solid ${CONSTS.colors.grey};
             
                &:first-child{
                    border-right: 1px solid ${CONSTS.colors.grey};
                    border-left: 1px solid ${CONSTS.colors.grey};
                    padding-right: 20px;
                    border-radius: 0 ${CONSTS.border.radius} ${CONSTS.border.radius2} 0;
                }
                &:last-child{
                    border-left: 1px solid ${CONSTS.colors.grey};
                    border-right: 1px solid ${CONSTS.colors.grey};
                    padding-left: 20px;
                    padding-right: 20px;
                    border-radius: ${CONSTS.border.radius} 0 0 ${CONSTS.border.radius2};
                }
                
            }
        }
    }
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        thead{
            font-size: 13px;
        }
    }
`

export default StyledTable;